import { useQuery } from '@apollo/client'
import { SearchableCombobox, TSearchable } from '../base/combobox'
import {
  MaintenanceScheduleSelectorQuery,
  SelectedMaintenanceScheduleSelectorQuery
} from './__generated__/selector_query'
import { Query, SelectedQuery } from './selector_query'
import { dedupe } from '@/helpers/dedupe'
import { useCombobox } from '@/helpers/useCombobox'

type AssetType = SelectedMaintenanceScheduleSelectorQuery['maintenanceSchedules']['nodes'][0]

interface Props {
  value: string
  onChange: (value: TSearchable | null) => void
  invalid: boolean
}

export const Selector = ({ value, onChange, invalid }: Props) => {
  const { data: selectedData } = useQuery<SelectedMaintenanceScheduleSelectorQuery>(
    SelectedQuery,
    { variables: { id: value || 'blank' } }
  )
  const { data, loading, refetch, fetchMore } = useQuery<MaintenanceScheduleSelectorQuery>(
    Query,
    { variables: { first: 10 } }
  )

  const { pageInfo, items } = useCombobox<AssetType>({
    pageInfo: data?.maintenanceSchedules.pageInfo,
    querySelected: selectedData?.maintenanceSchedules.nodes[0],
    queryCollection: data?.maintenanceSchedules.nodes,
    buildSearchable: item => ({
      id: item.id,
      name: item.summary,
    })
  })

  return (
    <SearchableCombobox
      data={items}
      invalid={invalid}
      loading={loading}
      moreToFetch={pageInfo.current?.hasNextPage}
      refetch={refetch}
      searchField="nameCont"
      value={items.find(d => d.id == value) || { id: '', name: '' }}
      fetchMore={() => fetchMore({
        variables: { after: pageInfo.current?.endCursor },
        updateQuery(previousData, { fetchMoreResult }) {
          if (Object.keys(previousData).length === 0) return fetchMoreResult
          fetchMoreResult.maintenanceSchedules.nodes = dedupe([
            ...previousData.maintenanceSchedules.nodes,
            ...fetchMoreResult.maintenanceSchedules.nodes
          ])

          return { ...fetchMoreResult }
        }
      })}
      onChange={onChange}
    />
  )
}
